import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss']
})
export class CguComponent implements OnInit {
  @Output() langChange = new EventEmitter<string>();

  frenchCgu:boolean = false;
  englishCgu:boolean = false;
  
  baseHref: string;
  htmlString: any;
  constructor() { }

  ngOnInit() {
    var base = document.getElementsByTagName('base');
    this.baseHref = base[0].href + "assets/cgu/cgu";
    
    if(navigator.language.includes('fr')){
      this.frenchCgu = true;
    } else {
      this.englishCgu = true;
    }
  }

  loadEnglishCgu(){
    if(this.frenchCgu == true){
      this.frenchCgu = false;
      this.englishCgu = true;
      this.langChange.next('en');
    }
  } 
  
  loadFrenchCgu(){
    if(this.englishCgu == true){
      this.englishCgu = false;
      this.frenchCgu = true;
      this.langChange.next('fr');
    }
  }

  getParamsInURL(language: string) {
    if(language == "fr")
      window.open(this.baseHref + "-FR.pdf");
    if(language == "en")
      window.open(this.baseHref + "-EN.pdf");
  }
}
